import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navFilter: '',
    };
  }

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else {
      const next = { ...this.state };
      Object.keys(next).forEach((k) => {
        if (k !== 'navFilter') next[k] = false;
      });
      next[menuState] = true;
      this.setState(next);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    if (typeof this.props.onNavigate === 'function') {
      this.props.onNavigate();
    }
    const dropdownPaths = [
      { path: '/admin', state: 'adminMenu' },
      { path: '/user', state: 'userMenu' },
      { path: '/challenge', state: 'challengeMenu' },
      { path: '/transaction', state: 'transactionMenu' },
      { path: '/Reports', state: 'reportsMenu' },
    ];
    const open = {};
    dropdownPaths.forEach(({ path, state }) => {
      if (this.isPathActive(path)) open[state] = true;
    });
    this.setState((s) => ({ ...s, ...open, navFilter: '' }));
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
  }

  navMatches(label) {
    const q = (this.state.navFilter || '').trim().toLowerCase();
    if (!q) return true;
    return String(label || '').toLowerCase().includes(q);
  }

  navItemClass(label, extra = '') {
    return `admin-sidebar-item ${extra} ${this.navMatches(label) ? '' : 'is-nav-hidden'}`.trim();
  }

  navParentClass(label, open) {
    const childVisible = this.navMatches(label);
    const q = (this.state.navFilter || '').trim();
    const show = !q || childVisible || open;
    return `admin-sidebar-parent ${open ? 'open' : ''} ${show ? '' : 'is-nav-hidden'}`.trim();
  }

  handleNavClick = () => {
    if (typeof this.props.onNavigate === 'function') {
      this.props.onNavigate();
    }
  };

  render() {
    const { usertype, isOffcanvasOpen, themeMode, onToggleTheme } = this.props;
    const isLight = (themeMode || 'light') === 'light';
    const filter = (this.state.navFilter || '').trim();
    const sidebarClass = [
      'sidebar',
      'sidebar-offcanvas',
      'admin-layout-sidebar',
      isOffcanvasOpen ? 'is-offcanvas-open' : '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <nav className={sidebarClass} id="sidebar" aria-label="Admin navigation">
        <div className="admin-sidebar-top">
          <div className="admin-sidebar-top-row">
            <Link to="/dashboard" className="admin-sidebar-brand" onClick={this.handleNavClick}>
              <span className="admin-sidebar-brand-mark">LP</span>
              <span>
                <div className="admin-sidebar-brand-text">Ludoflix</div>
                <div className="admin-sidebar-brand-sub">Admin Panel</div>
              </span>
            </Link>
            <button
              type="button"
              className="admin-sidebar-close"
              onClick={this.handleNavClick}
              aria-label="Close menu"
            >
              <span className="mdi mdi-close" />
            </button>
          </div>
          <div className="admin-sidebar-search-wrap">
            <span className="mdi mdi-magnify admin-sidebar-search-icon" />
            <input
              type="search"
              className="admin-sidebar-search"
              placeholder="Search menu…"
              value={this.state.navFilter}
              onChange={(e) => this.setState({ navFilter: e.target.value })}
              aria-label="Search menu"
            />
          </div>
        </div>

        <div
          className={`admin-sidebar-nav ${filter && !this.navMatches('x') ? '' : ''}`}
        >
          {this.navMatches('Main') || this.navMatches('Dashboard') || this.navMatches('Earnings') ? (
            <div className="admin-sidebar-label"><Trans>Main</Trans></div>
          ) : null}

          {this.props.dashboard && (
            <Link
              className={`${this.navItemClass('Dashboard')} ${this.isPathActive('/dashboard') ? 'active' : ''}`}
              to="/dashboard"
              onClick={this.handleNavClick}
            >
              <span className="admin-sidebar-icon"><i className="mdi mdi-view-dashboard" /></span>
              <span><Trans>Dashboard</Trans></span>
            </Link>
          )}
          {this.props.earning && (
            <Link
              className={`${this.navItemClass('Admin Earnings')} ${this.isPathActive('/earinigs') ? 'active' : ''}`}
              to="/earinigs"
              onClick={this.handleNavClick}
            >
              <span className="admin-sidebar-icon"><i className="mdi mdi-cash-usd" /></span>
              <span><Trans>Admin Earnings</Trans></span>
            </Link>
          )}

          {(this.props.allAdmins || this.props.newAdmin || this.props.sitesettings) && (
            <>
              {(filter || this.isPathActive('/admin')) && (
                <div className={`admin-sidebar-label ${this.navMatches('Admin') ? '' : 'is-nav-hidden'}`}>
                  <Trans>Admin</Trans>
                </div>
              )}
              <div className={this.navParentClass('Admin Manager', this.state.adminMenu)}>
                <div
                  className="admin-sidebar-item"
                  onClick={() => this.toggleMenuState('adminMenu')}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && this.toggleMenuState('adminMenu')}
                >
                  <span className="admin-sidebar-icon"><i className="mdi mdi-account-cog" /></span>
                  <span><Trans>Admin Manager</Trans></span>
                  <i className="mdi mdi-chevron-down admin-sidebar-arrow" />
                </div>
                <Collapse in={this.state.adminMenu || !!filter}>
                  <ul className="admin-sidebar-sub">
                    {this.props.allAdmins && (
                      <li>
                        <Link
                          className={`${this.navItemClass('All Admins')} ${this.isPathActive('/admin/alladmins') ? 'active' : ''}`}
                          to="/admin/alladmins"
                          onClick={this.handleNavClick}
                        >
                          <Trans>All Admins</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.newAdmin && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Add Admin')} ${this.isPathActive('/admin/addadmin') ? 'active' : ''}`}
                          to="/admin/addadmin"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Add New Admin</Trans>
                        </Link>
                      </li>
                    )}
                    {(this.props.allAdmins || this.props.sitesettings) && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Website Settings')} ${this.isPathActive('/admin/sitesettings') ? 'active' : ''}`}
                          to="/admin/sitesettings"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Website Settings</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.sitesettings && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Spin')} ${this.isPathActive('/admin/spin') ? 'active' : ''}`}
                          to="/admin/spin"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Spin wheel</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.sitesettings && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Bonus links')} ${this.isPathActive('/admin/bonus-links') ? 'active' : ''}`}
                          to="/admin/bonus-links"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Bonus links</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </Collapse>
              </div>
            </>
          )}

          {(this.props.allUsers || this.props.newUser || this.props.pendingKyc) && (
            <>
              <div className={`admin-sidebar-label ${filter ? '' : ''}`}><Trans>Users</Trans></div>
              <div className={this.navParentClass('User Manager', this.state.userMenu)}>
                <div
                  className="admin-sidebar-item"
                  onClick={() => this.toggleMenuState('userMenu')}
                  role="button"
                  tabIndex={0}
                >
                  <span className="admin-sidebar-icon"><i className="mdi mdi-account-group" /></span>
                  <span><Trans>User Manager</Trans></span>
                  <i className="mdi mdi-chevron-down admin-sidebar-arrow" />
                </div>
                <Collapse in={this.state.userMenu || !!filter}>
                  <ul className="admin-sidebar-sub">
                    {this.props.allUsers && (
                      <li>
                        <Link
                          className={`${this.navItemClass('All Users')} ${this.props.location.pathname === '/user/allusers' ? 'active' : ''}`}
                          to="/user/allusers"
                          onClick={this.handleNavClick}
                        >
                          <Trans>All Users</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allUsers && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Online')} ${this.props.location.pathname === '/user/online-players' ? 'active' : ''}`}
                          to="/user/online-players"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Online players</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allUsers && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Home online')} ${this.props.location.pathname === '/user/home-online-players' ? 'active' : ''}`}
                          to="/user/home-online-players"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Home online</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allUsers && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Recently online')} ${this.props.location.pathname === '/user/recently-online-players' ? 'active' : ''}`}
                          to="/user/recently-online-players"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Recently online (12h)</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allUsers && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Today new')} ${this.isPathActive('/user/today-new-users') ? 'active' : ''}`}
                          to="/user/today-new-users"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Today new users</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.newUser && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Add User')} ${this.isPathActive('/user/adduser') && !this.props.location.pathname.match(/\/user\/adduser\/.+/) ? 'active' : ''}`}
                          to="/user/adduser"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Add User</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.pendingKyc && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Pending KYC')} ${this.isPathActive('/user/UserKyc') ? 'active' : ''}`}
                          to="/user/UserKyc"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Pending KYC</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.completedKyc && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Completed KYC')} ${this.isPathActive('/user/kyc') ? 'active' : ''}`}
                          to="/user/kyc"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Completed KYC</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.rejectKyc && (
                      <li>
                        <Link
                          className={`${this.navItemClass('Reject KYC')} ${this.isPathActive('/user/reject') ? 'active' : ''}`}
                          to="/user/reject"
                          onClick={this.handleNavClick}
                        >
                          <Trans>Reject KYC</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </Collapse>
              </div>
            </>
          )}

          {(this.props.allChallenges || this.props.runningChallenges) && (
            <>
              <div className="admin-sidebar-label"><Trans>Challenges</Trans></div>
              <div className={this.navParentClass('Challenge Manager', this.state.challengeMenu)}>
                <div
                  className="admin-sidebar-item"
                  onClick={() => this.toggleMenuState('challengeMenu')}
                  role="button"
                  tabIndex={0}
                >
                  <span className="admin-sidebar-icon"><i className="mdi mdi-trophy" /></span>
                  <span><Trans>Challenge Manager</Trans></span>
                  <i className="mdi mdi-chevron-down admin-sidebar-arrow" />
                </div>
                <Collapse in={this.state.challengeMenu || !!filter}>
                  <ul className="admin-sidebar-sub">
                    {this.props.allChallenges && (
                      <li>
                        <Link className={`${this.navItemClass('All Challenges')} ${this.isPathActive('/challenge/allchallenges') ? 'active' : ''}`} to="/challenge/allchallenges" onClick={this.handleNavClick}>
                          <Trans>All Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.completedChallenges && (
                      <li>
                        <Link className={`${this.navItemClass('Completed')} ${this.isPathActive('/challenge/completed_challange') ? 'active' : ''}`} to="/challenge/completed_challange" onClick={this.handleNavClick}>
                          <Trans>Completed</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.conflictChallenges && (
                      <li>
                        <Link className={`${this.navItemClass('Conflict')} ${this.isPathActive('/challenge/conflict_challange') ? 'active' : ''}`} to="/challenge/conflict_challange" onClick={this.handleNavClick}>
                          <Trans>Conflict</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.cancelledChallenges && (
                      <li>
                        <Link className={`${this.navItemClass('Cancelled')} ${this.isPathActive('/challenge/cancelled_challange') ? 'active' : ''}`} to="/challenge/cancelled_challange" onClick={this.handleNavClick}>
                          <Trans>Cancelled</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.runningChallenges && (
                      <li>
                        <Link className={`${this.navItemClass('Running')} ${this.isPathActive('/challenge/running_challange') ? 'active' : ''}`} to="/challenge/running_challange" onClick={this.handleNavClick}>
                          <Trans>Running</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.dropChallenges && (
                      <li>
                        <Link className={`${this.navItemClass('Drop')} ${this.isPathActive('/challenge/drop_challange') ? 'active' : ''}`} to="/challenge/drop_challange" onClick={this.handleNavClick}>
                          <Trans>Drop</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.newChallenge && (
                      <li>
                        <Link className={`${this.navItemClass('New challenge')} ${this.isPathActive('/challenge/new_challange') ? 'active' : ''}`} to="/challenge/new_challange" onClick={this.handleNavClick}>
                          <Trans>New</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </Collapse>
              </div>
            </>
          )}

          {(this.props.penaltyBonus || this.props.allWithdrawlRequests) && (
            <>
              <div className="admin-sidebar-label"><Trans>Transactions</Trans></div>
              <div className={this.navParentClass('Transaction Manager', this.state.transactionMenu)}>
                <div
                  className="admin-sidebar-item"
                  onClick={() => this.toggleMenuState('transactionMenu')}
                  role="button"
                  tabIndex={0}
                >
                  <span className="admin-sidebar-icon"><i className="mdi mdi-swap-horizontal" /></span>
                  <span><Trans>Transaction Manager</Trans></span>
                  <i className="mdi mdi-chevron-down admin-sidebar-arrow" />
                </div>
                <Collapse in={this.state.transactionMenu || !!filter}>
                  <ul className="admin-sidebar-sub">
                    {this.props.penaltyBonus && (
                      <li>
                        <Link className={`${this.navItemClass('Penalty Bonus')} ${this.isPathActive('/transaction/penaltybonus') ? 'active' : ''}`} to="/transaction/penaltybonus" onClick={this.handleNavClick}>
                          <Trans>Penalty & Bonus</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.depositHistory && (
                      <li>
                        <Link className={`${this.navItemClass('Deposit History')} ${this.isPathActive('/transaction/transaction_history') ? 'active' : ''}`} to="/transaction/transaction_history" onClick={this.handleNavClick}>
                          <Trans>Deposit History</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.bonusHistory && (
                      <li>
                        <Link className={`${this.navItemClass('Bonus History')} ${this.isPathActive('/transaction/bonus_history') ? 'active' : ''}`} to="/transaction/bonus_history" onClick={this.handleNavClick}>
                          <Trans>Bonus History</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.withdrawlHistory && (
                      <li>
                        <Link className={`${this.navItemClass('Withdrawal History')} ${this.isPathActive('/transaction/withdraw') ? 'active' : ''}`} to="/transaction/withdraw" onClick={this.handleNavClick}>
                          <Trans>Withdrawal History</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allWithdrawlRequests && (
                      <li>
                        <Link className={`${this.navItemClass('Withdrawal Requests')} ${this.isPathActive('/transaction/allwithdrawl') ? 'active' : ''}`} to="/transaction/allwithdrawl" onClick={this.handleNavClick}>
                          <Trans>Withdrawal Requests</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allDepositRequests && (
                      <li>
                        <Link className={`${this.navItemClass('Deposit Requests')} ${this.isPathActive('/transaction/alldeposits') ? 'active' : ''}`} to="/transaction/alldeposits" onClick={this.handleNavClick}>
                          <Trans>Deposit Requests</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allDepositRequests && usertype === 'Admin' && (
                      <li>
                        <Link className={`${this.navItemClass('Find deposit')} ${this.isPathActive('/transaction/missing-deposit-requests') ? 'active' : ''}`} to="/transaction/missing-deposit-requests" onClick={this.handleNavClick}>
                          <Trans>Find my deposit</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </Collapse>
              </div>
            </>
          )}

          {(this.props.bonusReport || this.props.depositReport) && (
            <>
              <div className="admin-sidebar-label"><Trans>Reports</Trans></div>
              <div className={this.navParentClass('Reports', this.state.reportsMenu)}>
                <div
                  className="admin-sidebar-item"
                  onClick={() => this.toggleMenuState('reportsMenu')}
                  role="button"
                  tabIndex={0}
                >
                  <span className="admin-sidebar-icon"><i className="mdi mdi-chart-box" /></span>
                  <span><Trans>Reports</Trans></span>
                  <i className="mdi mdi-chevron-down admin-sidebar-arrow" />
                </div>
                <Collapse in={this.state.reportsMenu || !!filter}>
                  <ul className="admin-sidebar-sub">
                    {this.props.bonusReport && (
                      <li>
                        <Link className={`${this.navItemClass('Bonus Report')} ${this.isPathActive('/Reports/bonus_report') ? 'active' : ''}`} to="/Reports/bonusReport" onClick={this.handleNavClick}>
                          <Trans>Bonus Report</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.depositReport && (
                      <li>
                        <Link className={`${this.navItemClass('Deposit Report')} ${this.isPathActive('/Reports/deposit_report') ? 'active' : ''}`} to="/Reports/depositReport" onClick={this.handleNavClick}>
                          <Trans>Deposit Report</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.penaltyReport && (
                      <li>
                        <Link className={`${this.navItemClass('Penalty Report')} ${this.isPathActive('/Reports/penalty_report') ? 'active' : ''}`} to="/Reports/penaltyReport" onClick={this.handleNavClick}>
                          <Trans>Penalty Report</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.withdrawalReport && (
                      <li>
                        <Link className={`${this.navItemClass('Withdrawal Report')} ${this.isPathActive('/Reports/withdrawal_report') ? 'active' : ''}`} to="/Reports/withdrawalReport" onClick={this.handleNavClick}>
                          <Trans>Withdrawal Report</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </Collapse>
              </div>
            </>
          )}
        </div>

        <div className="admin-sidebar-footer">
          <button
            type="button"
            className="admin-sidebar-theme-btn"
            onClick={() => (typeof onToggleTheme === 'function' ? onToggleTheme() : null)}
            aria-label={isLight ? 'Switch to dark theme' : 'Switch to light theme'}
          >
            <span className={`mdi ${isLight ? 'mdi-weather-night' : 'mdi-white-balance-sunny'}`} />
            <span>{isLight ? 'Dark mode' : 'Light mode'}</span>
          </button>
        </div>
      </nav>
    );
  }
}

export default withRouter(Sidebar);
